<template>
  <div class="item-list">
    {{ serchForm.tagId }}
    <a-card style="margin: 10px 0">
      <div class="info-wrap">
        <div class="info-item">
          <div class="label">数据集ID：</div>
          <div class="value">{{ currentDataSet.id }}</div>
        </div>
        <div class="info-item">
          <div class="label">名称：</div>
          <a-input v-if="editing" v-model:value="form.chineseInstructions" autocomplete="off"></a-input>
          <div class="value" v-else>{{ currentDataSet.chineseInstructions }}</div>
        </div>
        <div class="info-item">
          <div class="label">说明：</div>
          <a-input v-if="editing" v-model:value="form.remark" autocomplete="off"></a-input>
          <div class="value" v-else :title="currentDataSet.remark">
            {{ currentDataSet.remark ? currentDataSet.remark.slice(0, 60) : '' }}
          </div>
        </div>
        <div class="info-item">
          <div class="label">数据类型：</div>
          <div class="value">{{ getDataTypeName(currentDataSet.itemTypeId) }}</div>
        </div>
        <div class="info-item">
          <div class="label">创建时间：</div>
          <div class="value">{{ getDateTime(currentDataSet.createTime) }}</div>
        </div>
        <div class="info-item">
          <div class="label">创建人：</div>
          <div class="value">{{ getUserName(currentDataSet.createUserId) }}</div>
        </div>
        <div class="info-item">
          <div class="label">更新时间：</div>
          <div class="value">{{ getDateTime(currentDataSet.updateTime) }}</div>
        </div>
        <div class="info-item">
          <div class="label">更新人：</div>
          <div class="value">{{ getUserName(currentDataSet.updateUserId) }}</div>
        </div>
        <div class="info-item">
          <div class="label">数据总量：</div>
          <div class="value">{{ total }}</div>
        </div>
      </div>
      <div class="ctrl-wrap"
        v-if="btnPerm.dataset.edit.indexOf(currentRole.roleId) !== -1">
        <a-button v-if="!editing" type="primary" @click="beginEdit">编辑</a-button>
        <a-button v-if="editing" type="primary" @click="handleSave">保存</a-button>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">数据列表</p>
      </div>
      <div class="searchBox mb20">
        <a-form
          layout="inline"
          :model="serchForm"
          @finish="handleFinish"
          @finishFailed="handleFinishFailed"
        >
          <!-- <a-form-item label="数据ID">
            <a-input v-model:value="serchForm.id" placeholder="">
            </a-input>
          </a-form-item> -->
          <a-form-item label="标签">
            <a-select
              v-model:value="serchForm.tags"
              mode="multiple"
              style="width:300px"
              placeholder=""
              :options="allTags.map((tag)=>{
                return {
                  value:tag.chineseInstructions,
                  label:tag.chineseInstructions,
                }
              })"
            >
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              查询
            </a-button>

            <a-button @click="creatDataItemHandle('creat')" style="margin-left: 30px;" type="primary">
              创建新数据集
            </a-button>
            <a-button @click="creatDataItemHandle('move')" class="ml20" type="primary">
              复制到数据集
            </a-button>
            <span class="ml20" style="vertical-align: middle;">全选<a-switch class="ml10" @change="switchAll" v-model:checked="linkForm.all" /></span>
          </a-form-item>
        </a-form>

      </div>
      <a-table
        ref="listTable"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, getCheckboxProps:getCheckboxProps, onChange: onSelectChange }"
        :columns="columns"
       
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span>
            <a @click="handlePreview(record)">预览</a>
            <a-divider type="vertical" />
            <a @click="openDetail(record)">查看</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <PreviewDialog ref="previewDialog" :list="carouselList" :defaultId="carouselPos"></PreviewDialog>
    <DetailDialog ref="detailDialog"
      :currentDataItem="currentDataItem"
      :attrTree="dataAttrData"
      :allTags="allTags"
      @update="getData"
      @updateTags="getAllTags"></DetailDialog>

    <a-modal v-model:visible="dataModal.visible" title="关联数据集" @ok="handleOk" @cancel="handleCancel">
      <a-form ref="linkFormRef" v-if="dataModal.type == 'creat'" :model="linkForm" :rules="linkFormRules" :label-col="linkForm.labelCol" :wrapper-col="linkForm.wrapperCol">
        <a-form-item name="chineseInstructions" v-if="dataModal.type == 'creat'" label="数据集名称">
          <a-input v-model:value.trim="linkForm.chineseInstructions" default-value="" placeholder="" />
        </a-form-item>
        <a-form-item name="remark" v-if="dataModal.type == 'creat'" label="说明">
          <a-textarea v-model:value="linkForm.remark" />
        </a-form-item>
      </a-form>

      <a-form ref="linkFormRef" v-else :model="linkForm" :rules="linkFormRules" :label-col="linkForm.labelCol" :wrapper-col="linkForm.wrapperCol">
        <a-form-item label="数据集" name="targetId">
           <!-- <a-select
            v-model:value="dataModal.name"
            show-search
            placeholder=""
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :options="dataModal.items"
            @search="handleSearch"
            @popupScroll="handleScroll"
            @change="handleChange"
          >
          </a-select> -->
          
          <a-select
            v-model:value="linkForm.targetId"
            @popupScroll="loadDataset"
          >
            <a-select-option v-for="item in linkForm.dataSet.list"
              :key="item.id" :addition="item.addition">
              {{ item.chineseInstructions }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>

    </a-modal>
  </div>
</template>
<script>
import { getTagLabel } from '@/api/tagLabel'
import { getAllAttrCategory, getAttrValue, getAttrSubValue } from '@/api/dataAttr'
import PreviewDialog from '../DataItem/PreviewDialog'
import DetailDialog from '../DataItem/DetailDialog'
import { getDateTime, getUserName, getDataTypeName } from '@/filters'
import { getDataSetByPages, updateDataSet,findItemsByDataset, getAllData, createDatasetFormDataset, addItemToDataset } from '@/api/dataSet'
import { mapState } from 'vuex'
import config from '@/config'

import { defineComponent, reactive, ref, getCurrentInstance, onMounted, toRefs } from 'vue';
import { message } from 'ant-design-vue'

const columns = [
  {
    title: '上传ID',
    dataIndex: 'uploadRecordId'
  },
  {
    title: '数据ID',
    dataIndex: 'id'
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]
export default {
  components: {
    DetailDialog,
    PreviewDialog
  },

  setup(){

    onMounted(() => {
      getDataMap()
    })

    const instance = getCurrentInstance()
    console.log(instance)
    const serchForm = reactive({
      id: '',
      tags: [],
      tagIds:[],
    });


    

    const switchAll = (v)=>{
      chooseData.selectedRowKeys = []
      instance.ctx.getData(instance.data.page.pageNum )
    }
   

    const handleFinish = values => {
      chooseData.selectedRowKeys = []
      instance.ctx?.getData(1)
      console.log(values, serchForm);
    
    };
    const handleFinishFailed = errors => {
      console.log(errors);
    };



    function creatDataItemHandle(type){
      if(linkForm.all || chooseData.selectedRowKeys.length > 0){
        dataModal.visible = true
        dataModal.type = type
      }else{
        message.error('请先选择数据')
      }
    
    }


    const dataModal = reactive({
      visible:false,
      type:'creat',  //move
      form:{
        dataId:'',
        description:'',
      },
      items:[]
    })


    const linkForm = reactive({
      all:true,
      labelCol:{
        span: 5,
      },
      wrapperCol:{
        span: 18,
      },
      
      targetId:'',
      dataSet:{
        list:[],
        page: {
          pageNum: 1,
          pageSize: 30
        },
        more:false
      },
      
      
      chineseInstructions : '',
      remark : ''

    })


    const linkFormRules = {
      chineseInstructions: [
        { required: true, message: '名称不能为空', trigger: 'blur' },
      ],
      targetId: [
        { required: true, message: '数据集不能为空', trigger: 'change' },
      ],
    };



    const chooseData = reactive({
      selectedRowKeys:[]
    })





    var getCheckboxProps = (recored)=>{
      return {
        disabled: linkForm.all
      }
    }




    //获取数据集
    function getDataMap(){ 
      getAllData({ ...linkForm.dataSet.page, parentId: 'nullValue', field: 'createTime', order: 'desc' }).then(({data:res})=>{
        const arr = linkForm.dataSet.list
        res.map.data.rows.forEach((row, index, arr)=>{
          if(row.id == instance.data?.currentDataSet?.id){
            arr.splice(index, 1)
          }
        })

        linkForm.dataSet.list = arr.concat(res.map.data.rows)

        if (linkForm.dataSet.list.length <= res.map.data.total) {
          linkForm.dataSet.more = true
        } else {
          linkForm.dataSet.more = false
        }
      })
    }


    const handleSearch = (val) => {
      //调用查询接口
    }



    //数据集滚动事件
    const loadDataset = (e) => {
      if(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10 && linkForm.dataSet.more) {
        const num = linkForm.dataSet.page.pageNum
        linkForm.dataSet.page.pageNum = num + 1
        getDataMap()
      }
    }


    const linkFormRef = ref();

    const handleCancel = e => {}

    const handleOk = e => {
      debugger
      console.log(e);
      linkFormRef.value
      .validate()
      .then(() => {
        let ajaxData  = {
          datasetId: instance.data?.currentDataSet.id,
          tagIds:serchForm.tagIds
        }

        if(dataModal.type == 'creat'){
          ajaxData.chineseInstructions = linkForm.chineseInstructions
          if(!linkForm.all){    // 非全选
            ajaxData.itemIds = [...chooseData.selectedRowKeys]
            ajaxData.remark = linkForm.remark
          }else{
            if( ajaxData.itemIds ){
              delete ajaxData.itemIds
            }
           
          }

          createDatasetFormDataset(ajaxData).then(({data:res})=>{
            if(res.state == 'success'){
              dataModal.visible = false
              message.success('操作成功')
            }else{
              message.error('操作失败')
            }
          })
        }else{
          ajaxData.targetDatasetId = linkForm.targetId
          if(!linkForm.all){    // 非全选
            ajaxData.itemIds = [...chooseData.selectedRowKeys]
          }else{
            if( ajaxData.itemIds ){
              delete ajaxData.itemIds
            }
          }

          addItemToDataset(ajaxData).then(({data:res})=>{
            if(res.state == 'success'){
              dataModal.visible = false
              message.success('操作成功')
            }else{
              message.error('操作失败')
            }
          })
        }

        //console.log('values', formState, toRaw(formState));
      })
      .catch(error => {
        console.log('error', error);
        message.error(error)
      });
      
    };


    const rowSelection = {
     // selectedRowKeys: selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        debugger
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        chooseData.selectedRowKeys = selectedRowKeys
      },
      onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.log(selected, selectedRows, changeRows);
      },
    };


    const onSelectChange = selectedRowKeys => {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      chooseData.selectedRowKeys = selectedRowKeys;
    };

    return {
      serchForm,

      handleFinish,
      handleFinishFailed,

      ...toRefs(chooseData),
      rowSelection,
      onSelectChange,

     

      handleCancel,
      handleOk,
      dataModal,
      creatDataItemHandle,
      linkForm,
      linkFormRef,
      linkFormRules,
      handleSearch,
      loadDataset,
      switchAll,
      getCheckboxProps

    };
  },

  data () {
    return {
      btnPerm: config.btnPerm,
      datasetId: '',
      currentDataSet: {},
      editing: false,
      form: {
        chineseInstructions: '',
        remark: ''
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      columns,
      total: 0,
      carouselList: [],
      carouselPos: 0,
      currentDataItem: {},
      allTags: [],
      dataAttrData: []
    }
  },
  
  watch:{
    'serchForm.tags':{
      handler(){
        this.serchForm.tagIds = []
        this.allTags.forEach((alltag)=>{
        this.serchForm.tags.forEach((tag)=>{
          if(alltag.chineseInstructions == tag){
            this.serchForm.tagIds.push(alltag.id)
          }
        })
      })


        
      },
      immediate:true
    }
  },

  computed: {
    ...mapState(['currentRole'])
  },
  async mounted () {
    this.datasetId = this.$route.params.id
    if (!this.datasetId) {
      this.$router.push({ name: 'dataSet' })
    }
    getDataSetByPages({ id: this.datasetId }).then(res => {
      const data = res.data.map.data.rows
      if (data[0]) {
        this.currentDataSet = data[0]
        this.$store.commit('setBreadDatasetName', this.currentDataSet.chineseInstructions)
      } else {
        this.$message.error('数据集不存在')
      }
    })
    await this.getAllTags().catch(e => e)
    await this.getDataAttr().catch(e => e)
    this.getData(1)
  },
  methods: {
    getDateTime,
    getUserName,
    getDataTypeName,
    beginEdit () {
      this.form.chineseInstructions = this.currentDataSet.chineseInstructions
      this.form.remark = this.currentDataSet.remark
      this.editing = true
    },
    handleSave () {
      this.editing = false
      updateDataSet({
        ...this.form,
        id: this.currentDataSet.id
      }).then(res => {
        this.currentDataSet.chineseInstructions = this.form.chineseInstructions
        this.currentDataSet.remark = this.form.remark
        this.$message.success('修改成功')
      }).catch(err => {
        this.$message.error(err.response.data.message)
      })
    },
    getAllTags () {
      return getTagLabel().then(res => {
        this.allTags = res.data.map.data.rows
      })
    },
    async getDataAttr () {
      const res = await getAllAttrCategory().catch(e => e)

      this.dataAttrData = res.data.map.data
      
    },

    getData (pageNum) {    
      if (pageNum) this.page.pageNum = pageNum 
      findItemsByDataset({
        datasetId: this.datasetId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        itemIds: [],
        tagIds:this.serchForm.tagIds 
      }).then(({data:res})=>{
        this.total = res.map.data.total
        this.tableData = res.map.data.rows
      })
      // getDataset({
      //   datasetId: this.datasetId,
      //   pageNum: this.page.pageNum,
      //   pageSize: this.page.pageSize
      // }).then(res => {
      //   debugger
      //   this.total = res.total
      //   this.tableData = res.data
      // })
    },



    handlePreview (item) {
      this.carouselList = []
      for (let i = 0; i < this.tableData.length; i++) {
        this.carouselList.push({
          id: i,
          url: this.tableData[i].accessSrc
        })
        if (item.id === this.tableData[i].id) {
          this.carouselPos = i
        }
      }
      this.$refs.previewDialog.open()
    },
    // 查看数据
    openDetail (item) {
      this.currentDataItem = item
      this.$refs.detailDialog.open()
    }
  }
}
</script>
<style lang="less">
.item-list {
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 33%;
      padding: 20px; box-sizing: border-box;
      display: flex;
      .label {
        width: 70px; flex-shrink: 0;
      }
      .value {
        width: calc(100% - 70px);
      }
    }
  }
  .ctrl-wrap {
    text-align: right;
  }
}
</style>
